<template>
  <v-container>
    <v-form ref="form" v-model="isValid">
      <v-alert v-if="error" type="error" dense outlined>
        В форме содержатся ошибки - кол-во должно быть числом. Мы подсветили проблемные места красным цветом.
        Исправьте эти поля и попробуйте снова.
      </v-alert>

      <v-card> <!-- Этап 0. Демонтаж -->
        <v-card-title>
          Этап 0. Демонтажные работы
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.dismantling.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.dismantling.isActive">
          <v-radio-group v-model="entity.dismantling.isFull">
            <v-radio :value="true">
              <template v-slot:label>
                <div>
                  <strong>Полный демонтаж</strong>
                  <p>Подходит для вторички: сносятся все лишние стены, производится демонтаж стяжки, штукатурки со стен, демонтаж потолков, старой сантехники и электрики.</p>
                </div>
              </template>
            </v-radio>
            <v-radio :value="false">
              <template v-slot:label>
                <div>
                  <strong>Отдельные работы по демонтажу</strong>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <template v-if="!entity.dismantling.isFull">
            <services-list v-model="entity.dismantling.services"></services-list>
            <selected-services v-model="entity.dismantling.services"></selected-services>
          </template>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Этап 1. Проект -->
        <v-card-title>
          Этап 1. Проектирование
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.design.isActive"
          ></v-switch>
          
        </v-card-title>
        <v-card-text v-if="entity.design.isActive">
          <v-radio-group v-model="entity.design.package">
          <v-row class="pt-0 mt-0">
            <v-col cols="12" sm="4">
              <v-card style="height: 100%;">
                <v-card-title class="subtitle-2" @click="entity.design.package = 'simple'">
                  <v-radio value="simple"></v-radio>
                  Планировочное решение  
                </v-card-title>
                <v-card-text>
                  <v-divider></v-divider>
                  <div>
                    Включает в себя 3 варианта планировки вашего объекта на выбор.
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card style="height: 100%;">
                <v-card-title class="subtitle-2" @click="entity.design.package = 'standart'">
                  <v-radio value="standart"></v-radio>
                  Рабочая документация
                </v-card-title>
                <v-card-text>
                  <v-divider></v-divider>
                  <div>
                    Полный комплект рабочих чертежей для строителей: снос и возведение стен; план полов, стен и потолков; электрика; сантехника; вентиляция.
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card style="height: 100%;">
                <v-card-title class="subtitle-2" @click="entity.design.package = 'full'">
                  <v-radio value="full"></v-radio>
                  Полный дизайн-проект
                </v-card-title>
                <v-card-text>
                  <v-divider></v-divider>
                  <div>
                    Помимо рабочей документации, включает в себя подбор отделочных материалов, комплектации и мебели.
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-radio-group>
          <v-card>
            <v-card-title class="subtitle-2">
              3D-визуализации
            </v-card-title>
            <v-card-text>
              <v-alert type="warning" outlined dense>
                <template v-if="entity.design.package == 'full'">
                  Укажите число помещений (комнат), по которым необходимо сделать 3D-визуализации.
                </template>
                <template v-else>
                  Услуга доступна только в комплекте с Полным-дизайном проектом.
                </template>
              </v-alert>
              <v-text-field
                v-if="entity.design.package == 'full'"
                v-model="entity.design.plan3d"
                label="Кол-во помещений (комнат)"
                filled
                :rules="[v => isNumber(v) || 'Введите целое число.']"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Этап 2. Черновые -->
        <v-card-title>
          Этап 2. Черновые работы
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.whitebox.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.whitebox.isActive">
          <v-alert type="info" dense outlined>
            Задача чернового этапа - создать так называемый "whitebox" - состояние объекта, когда все 
            строительные конструкции возведены, все поверхности выровнены и подготовлены к финишной отделке.
          </v-alert>
          <v-card> <!-- 2.1. Возведение стен и перегородок -->
            <v-card-title class="subtitle-1">
              2.1. Возведение стен и перегородок
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.whitebox.newWalls.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.whitebox.newWalls.isActive">
              <v-row class="d-flex">
                <v-col cols="12" class="subtitle-2">
                  Возведение новых перегородок
                </v-col>
                <v-col 
                  cols="12" 
                  sm="3"
                  v-for="item of entity.whitebox.newWalls.services1"
                  :key="item.name"
                >
                  <v-text-field
                    :label="item.text"
                    v-model="item.value"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    suffix="м²"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="d-flex">
                <v-col cols="12" class="subtitle-2">
                  Обшивка стен
                </v-col>
                <v-col 
                  cols="12" 
                  sm="4"
                  v-for="item of entity.whitebox.newWalls.services2"
                  :key="item.name"
                >
                  <v-text-field
                    :label="item.text"
                    v-model="item.value"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    suffix="м²"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="d-flex">
                <v-col cols="12" class="subtitle-2">
                  Устройство проемов и люков
                </v-col>
                <v-col 
                  cols="12" 
                  sm="4"
                  v-for="item of entity.whitebox.newWalls.services3"
                  :key="item.name"
                >
                  <v-text-field
                    :label="item.text"
                    v-model="item.value"
                    filled
                    :rules="[v => isNumber(v) || 'Введите целое число']"
                    suffix="шт"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!--2.2. Электромонтажные работы -->
            <v-card-title class="subtitle-1">
              2.2. Черновая электрика
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.whitebox.electric.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.whitebox.electric.isActive">
              <v-row>
                <v-col 
                  cols="12" 
                  sm="4"
                  v-for="item of entity.whitebox.electric.services"
                  :key="item.name"
                >
                  <v-text-field
                    :label="item.text"
                    v-model="item.value"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    :suffix="item.suffix"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 2.3. Сантехнические работы -->
            <v-card-title class="subtitle-1">
              2.3. Черновая сантехника
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.whitebox.water.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.whitebox.water.isActive">
              <v-row class="d-flex">
                <v-col cols="12" class="subtitle-2">
                  Разводка труб водоснабжения и канализации
                </v-col>
                <v-col cols="12" sm="4">
                  <v-select
                    label="Материал труб"
                    v-model="entity.whitebox.water.services1.selectedItem"
                    :items="entity.whitebox.water.services1.items"
                    filled
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    label="Число сантех. точек"
                    v-model="entity.whitebox.water.services1.value"
                    filled
                    :rules="[v => isNumber(v) || 'Введите целое число.']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="5">
                  <v-alert dense outlined>
                    <small>Сантехническая точка - это любой вывод воды или канализации.</small>
                  </v-alert>
                </v-col>
              </v-row>

              <v-row class="d-flex">
                <v-col cols="12" class="subtitle-2">
                  Дополнительные работы
                </v-col>
                <v-col cols="12">
                  <services-list v-model="entity.whitebox.water.services2"></services-list>
                  <selected-services v-model="entity.whitebox.water.services2"></selected-services>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          
          <v-card class="mt-5"> <!-- 2.4. Подготовка стен -->
            <v-card-title class="subtitle-1">
              2.4. Подготовка стен
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.whitebox.walls.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.whitebox.walls.isActive">
              <layers-selector
                :value="entity.whitebox.walls.layers"
              ></layers-selector>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 2.5. Подготовка откосов -->
            <v-card-title class="subtitle-1">
              2.5. Подготовка откосов
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.whitebox.slopes.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.whitebox.slopes.isActive">
              <layers-selector
                :value="entity.whitebox.slopes.layers"
              ></layers-selector>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 2.6. Стяжка и подготовка пола -->
            <v-card-title class="subtitle-1">
              2.6. Стяжка и подготовка пола
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.whitebox.floors.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.whitebox.floors.isActive">
              <layers-selector
                :value="entity.whitebox.floors.layers"
              ></layers-selector>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 2.7. Подготовка потолков -->
            <v-card-title class="subtitle-1">
              2.7. Подготовка потолков
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.whitebox.ceiling.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.whitebox.ceiling.isActive">
              <layers-selector
                :value="entity.whitebox.ceiling.layers"
              ></layers-selector>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 2.8. Прочее -->
            <v-card-title class="subtitle-1">
              2.8. Прочие работы
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
             <v-row class="d-flex">
                <v-col cols="12" sm="4">
                  <v-text-field
                    label="Число точек вентиляции"
                    v-model="entity.whitebox.others.ventPoints"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    suffix="шт"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    label="Число кондиционеров"
                    v-model="entity.whitebox.others.airConditioners"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    suffix="шт"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-switch
                    :label="`Замена входной двери: ${entity.whitebox.others.mainDoor ? 'да' : 'нет'}`"
                    v-model="entity.whitebox.others.mainDoor"
                    filled
                  ></v-switch>
                </v-col>
             </v-row>
            </v-card-text>
          </v-card>
          
        </v-card-text>
      </v-card>

      <v-card class="mt-7"> <!-- Этап 3. Чистовые -->
        <v-card-title>
          Этап 3. Чистовые работы
          <v-spacer></v-spacer>
          <v-switch
            v-model="entity.finishing.isActive"
          ></v-switch>
        </v-card-title>
        <v-card-text v-if="entity.finishing.isActive">
          <v-alert type="info" dense outlined>
            В ходе чистового этапа работ мы наносим финишные покрытия, устанавливаем оборудование и готовим объект к сдаче. 
            Конечный результат данного этапа - объект, реализованный в соответствие с задачей клиента. 
            И новоселье &#127870;
          </v-alert>

          <v-card class="mt-5"> <!-- 3.1. Cтены -->
            <v-card-title class="subtitle-1">
              3.1. Отделка стен
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.finishing.walls.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.finishing.walls.isActive">
              <layers-selector
                :value="entity.finishing.walls.layers"
              ></layers-selector>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 3.2. Откосы -->
            <v-card-title class="subtitle-1">
              3.2. Отделка откосов
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.finishing.slopes.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.finishing.slopes.isActive">
              <layers-selector
                :value="entity.finishing.slopes.layers"
              ></layers-selector>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 3.3. Полы -->
            <v-card-title class="subtitle-1">
              2.6. Отделка пола
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.finishing.floors.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.finishing.floors.isActive">
              <div>
                <span class="subtitle-2">Финишное покрытие</span>
                <layers-selector
                  :value="entity.finishing.floors.layers1"
                ></layers-selector>
              </div>
              <div class="mt-3">
                <span class="subtitle-2">Плинтус и пороги</span>
                <layers-selector
                  :value="entity.finishing.floors.layers2"
                ></layers-selector>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 3.4. Потолки  -->
            <v-card-title class="subtitle-1">
              3.4. Отделка потолков
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.finishing.ceiling.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.finishing.ceiling.isActive">
              <layers-selector
                :value="entity.finishing.ceiling.layers"
              ></layers-selector>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!--3.5. Электромонтажные работы -->
            <v-card-title class="subtitle-1">
              3.5. Подключение электроприборов
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.finishing.electric.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.finishing.electric.isActive">
              <v-row>
                <v-col 
                  cols="12" 
                  sm="4"
                  v-for="item of entity.finishing.electric.services"
                  :key="item.name"
                >
                  <v-text-field
                    :label="item.text"
                    v-model="item.value"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    suffix="шт"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!--3.6. Сантехнические работы -->
            <v-card-title class="subtitle-1">
              3.6. Подключение сантехприборов
              <v-spacer></v-spacer>
              <v-switch
                v-model="entity.finishing.water.isActive"
              ></v-switch>
            </v-card-title>
            <v-card-text v-if="entity.finishing.water.isActive">
              <v-row>
                <v-col 
                  cols="12" 
                  sm="4"
                  v-for="item of entity.finishing.water.services"
                  :key="item.name"
                >
                  <v-text-field
                    :label="item.text"
                    v-model="item.value"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    suffix="шт"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mt-5"> <!-- 3.7. Финал -->
            <v-card-title class="subtitle-1">
              3.7. Финальные работы
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
             <v-row class="d-flex">
                <v-col cols="12" sm="4">
                  <v-text-field
                    label="Установка межкомнатных дверей"
                    v-model="entity.finishing.others.doors"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    suffix="шт"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    label="Установка зеркал"
                    v-model="entity.finishing.others.mirrors"
                    filled
                    :rules="[v => isNumber(v) || 'Введите число']"
                    suffix="шт"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-switch
                    :label="`Финальная уборка: ${entity.finishing.others.cleaning ? 'да' : 'нет'}`"
                    v-model="entity.finishing.others.cleaning"
                    filled
                  ></v-switch>
                </v-col>
             </v-row>
            </v-card-text>
          </v-card>

        </v-card-text>
      </v-card>
    </v-form>
    <div class="mt-7 d-flex">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="cancel()" class="mr-2">Назад</v-btn>
      <v-btn color="primary" @click="save()">Продолжить</v-btn>
    </div>
  </v-container>
</template>

<script>
import ServicesList from './constructor_services/ConstructorServicesList';
import SelectedServices from './constructor_services/ConstructorSelectedServices';
import LayersSelector from './constructor_services/ConstructorLayersSelector';

export default {
  components: {
    ServicesList,
    SelectedServices,
    LayersSelector,
    
  },

  props: {
    objParams: Object,
    price: Object
  },

  data() {
    return {
      isValid: false,
      error: false,
      entity: this.getDefaultEntity(),
    }
  },

  methods: {
    /*
      floor_square: 0,
      walls_square: 0,
      ceiling_square: 0,
      floor_perimeter: 0,
      ceiling_perimeter: 0,
      slopes_length: 0,
      windowsill_length: 0,
      electric_points_count: 0,
      water_points_count: 0
    */
    getObjectParam(tag, mod) {
      return this.objParams.rooms.reduce((sum, cur) => sum + Number(cur.finalParams[tag]), 0);
    },

    getRoomsValues(tag, empty = false, defaultRoomCounts = false) {
      if (empty) {
        return [
        {
          isActive: false,
          name: 'ПО ОБЪЕКТУ',
          value: 0,
          _value: 0,
          default: defaultRoomCounts ? this.objParams.rooms.length : 0
        },
        ...this.objParams.rooms.map(x => ({
          isActive: false,
          name: x.name,
          value: 0,
          _value: 0,
          default: 0
      }))];
      }

      return [
        {
          isActive: false,
          name: 'ПО ОБЪЕКТУ',
          value: 0,
          _value: 0,
          default: this.getObjectParam(tag)
        },
        ...this.objParams.rooms.map(x => ({
          isActive: false,
          name: x.name,
          roomType: x.roomType,
          value: 0,
          _value: 0,
          default: x.finalParams[tag]
      }))];
    },

    getDefaultEntity() {
      return {
        dismantling: { // Демонтажные работы
          isActive: false,
          isFull: true,
          services: this.price.services.filter(x => x.categoryName == 'ДЕМОНТАЖНЫЕ РАБОТЫ')
        },
        design: { // Проектирование
          isActive: false,
          package: 'simple',
          plan3d: 0,
        },
        whitebox: { // Черновые работы
          isActive: false,
          newWalls: {
            isActive: false,
            services1: [
              {
                text: 'Пеноблок',
                original: 'Возведение перегородок из пеноблоков (газоблоков)',
                value: 0
              },
              {
                text: 'Кирпич',
                original: 'Возведение перегородок из кирпича (толщина 0.5)',
                value: 0
              },
              {
                text: 'ПГБ',
                original: 'Возведение перегородок из ПГБ',
                value: 0
              },
              {
                text: 'ГКЛ',
                original: 'Возведение перегородок из ГКЛ',
                value: 0
              },
            ],
            services2: [
              {
                text: 'ГКЛ (без каркаса)',
                original: 'Обшивка стен листами ГКЛ (без каркаса)',
                value: 0
              },
              {
                text: 'ГКЛ (на каркасе)',
                original: 'Обшивка стен листами ГКЛ (с устройством каркаса)',
                value: 0
              },
              {
                text: 'ПЕНОПЛЕКС',
                original: 'Тепло-звуко-изоляция стен и перегородок (ПЕНОПЛЕКС)',
                value: 0
              },
              
            ],
            services3: [
              {
                text: 'Проем двери (с усилением)',
                original: 'Изготовление проема двери с усилением',
                value: 0
              },
              {
                text: 'Ревизионный люк (простой)',
                original: 'Устройство ревизионного люка',
                value: 0
              },
              {
                text: 'Ревизионный люк (скрытый)',
                original: 'Устройство скрытого ревизионного люка',
                value: 0
              },
            ]
          },
          electric: {
            isActive: false,
            services: [
              {
                text: 'Число электроточек',
                original: 'Устройство электроточки',
                value: this.getObjectParam('electric_points_count'),
                suffix: 'шт'
              },
              {
                text: 'Число электрощитов',
                original: 'Сборка и монтаж электрощита',
                value: 1,
                suffix: 'шт'
              },
              {
                text: 'Теплый пол',
                original: 'Устройство теплого пола',
                value: 0,
                suffix: 'м²'
              },
            ]
          },
          water: {
            isActive: false,
            services1: {
              items: [
                {
                  text: 'Полипропилен',
                  value: 'Устройство сантехнической точки из полипропилена'
                },
                {
                  text: 'Сшитый полиэтилен',
                  value: 'Устройство сантехнической точки из сшитого полиэтилена',
                },
                {
                  text: 'Металлопласт',
                  value: 'Устройство сантехнической точки из металлопласта'
                }
              ],
              selectedItem: 'Устройство сантехнической точки из полипропилена',
              value: this.getObjectParam('water_points_count')
            },
            services2: this.price.services.filter(x => 
              x.categoryName == 'САНТЕХНИЧЕСКИЕ РАБОТЫ' && 
              x.subCategoryName == 'Черновая сантехника' &&
              x.name != 'Устройство сантехнической точки из полипропилена' && 
              x.name != 'Устройство сантехнической точки из сшитого полиэтилена' &&
              x.name != 'Устройство сантехнической точки из металлопласта')
          },
          walls: {
            isActive: false,
            layers: [
              {
                name: 'Грунтование',
                tag: 'priming',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Грунтование стен',
              },
              {
                name: 'Гидроизоляция',
                tag: 'waterproofing',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Гидроизоляция стен обмазочной смесью',
              },
              {
                name: 'Штукатурка 1см (под правило)',
                tag: 'plaster1',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Штукатурка стен под правило слоем 1 см (гипсовая штукатурка)',
                originalWater: 'Штукатурка стен под правило слоем 1 см (цементная штукатурка)',
              },
              {
                name: 'Штукатурка 2см (по маякам)',
                tag: 'plaster2',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Штукатурка стен по маякам слоем 2 см (гипсовая штукатурка)',
                originalWater: 'Штукатурка стен по маякам слоем 2 см (цементная штукатурка)',
              },
              {
                name: 'Штукатурка 4см (по маякам)',
                tag: 'plaster4',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Штукатурка стен по маякам слоем 4 см (гипсовая штукатурка)',
                originalWater: 'Штукатурка стен по маякам слоем 4 см (цементная штукатурка)',
              },
              {
                name: 'Штукатурка 6см (по маякам)',
                tag: 'plaster6',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Штукатурка стен по маякам слоем 6 см (гипсовая штукатурка)',
                originalWater: 'Штукатурка стен по маякам слоем 6 см (цементная штукатурка)',
              },
              {
                name: 'Подготовка под обои',
                tag: 'wallpaper',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                originalPie: [
                  'Шпаклевка стен в 1 слой',
                  'Шлифование стен',
                ]
              },
              {
                name: 'Подготовка под покраску',
                tag: 'painting',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                originalPie: [
                  'Шпаклевка стен в 2 слоя',
                  'Наклеивание стеклоткани на стену',
                  'Шлифование стен'
                ]
              },
            ],
          },
          slopes: {
            isActive: false,
            layers: [
              {
                name: 'Грунтование',
                tag: 'priming',
                value: this.getRoomsValues('slopes_length'),
                suffix: 'мп',
                original: 'Грунтование откосов'
              },
              {
                name: 'Штукатурка',
                tag: 'plaster',
                value: this.getRoomsValues('slopes_length'),
                suffix: 'мп',
                original: 'Штукатурка откосов'
              },
              {
                name: 'Отделка ГКЛ',
                tag: 'drywall',
                value: this.getRoomsValues('slopes_length'),
                suffix: 'мп',
                original: 'Отделка откоса ГКЛ'
              },
              {
                name: 'Подготовка под покраску',
                tag: 'painting',
                value: this.getRoomsValues('slopes_length'),
                suffix: 'мп',
                originalPie: [
                  'Шпаклевка откосов в 2 слоя',
                  'Наклеивание стеклоткани на откосы',
                  'Шлифование откосов'
                ]
              },
            ]
          },
          floors: {
            isActive: false,
            layers: [
              {
                name: 'Грунтование',
                tag: 'priming',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Грунтование пола'
              },
              {
                name: 'Гидроизоляция',
                tag: 'waterproofing',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Гидроизоляция пола обмазочной смесью'
              },
              {
                name: 'Шумоизоляция',
                tag: 'stopnoise',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Устройство шумоизоляции полов (ШУМАНЕТ)'
              },
              {
                name: 'Подушка из керамзита',
                tag: 'haydite',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Устройство керамзитовой подушки под стяжку слоем 10 см'
              },
              {
                name: 'Стяжка 5 см',
                tag: 'screed5',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Устройство стяжки пола слоем 5 см'
              },
              {
                name: 'Стяжка 10 см',
                tag: 'screed10',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Устройство стяжки пола слоем 10 см'
              },
              {
                name: 'Наливной пол',
                tag: 'self-leveling',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Выравнивание пола наливной смесью'
              },
              {
                name: 'Укладка фанеры',
                tag: 'plywood',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка фанеры в 1 слой'
              },
            ]
          },
          ceiling: {
            isActive: false,
            layers: [
              {
                name: 'Грунтование',
                tag: 'priming',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Грунтование потолков'
              },
              {
                name: 'Тепло-пароизоляции',
                tag: 'vaporproofing',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Монтаж тепло-пароизоляции потолка'
              },
              {
                name: 'Штукатурка 1см (под правило)',
                tag: 'plaster1',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Штукатурка потолков под правило слоем 1 см (гипсовая штукатурка)',
                originalWater: 'Штукатурка потолков под правило слоем 1 см (цементная штукатурка)',
              },
              {
                name: 'Штукатурка 2см (по маякам)',
                tag: 'plaster2',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Штукатурка потолков по маякам слоем 2 см (гипсовая штукатурка)',
                originalWater: 'Штукатурка потолков по маякам слоем 2 см (цементная штукатурка)',
              },
              {
                name: 'Штукатурка 4см (по маякам)',
                tag: 'plaster4',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Штукатурка потолков по маякам слоем 4 см (гипсовая штукатурка)',
                originalWater: 'Штукатурка потолков по маякам слоем 4 см (цементная штукатурка)',
              },
              {
                name: 'Штукатурка 6см (по маякам)',
                tag: 'plaster6',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Штукатурка потолков по маякам слоем 6 см (гипсовая штукатурка)',
                originalWater: 'Штукатурка потолков по маякам слоем 6 см (цементная штукатурка)',
              },
              {
                name: 'Потолок из ГКЛ (1 уровень)',
                tag: 'gfc1',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Монтаж потолка из ГКЛ (1 уровень)'
              },
              {
                name: 'Потолок из ГКЛ (2 уровня)',
                tag: 'gfc1',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Монтаж потолка из ГКЛ (2 уровня)'
              },
              {
                name: 'Подготовка под обои',
                tag: 'wallpaper',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                originalPie: [
                  'Шпаклевка потолков в 1 слой',
                  'Шлифование потолков'
                ]
              },
              {
                name: 'Подготовка под покраску',
                tag: 'painting',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                originalPie: [
                  'Шпаклевка потолков в 2 слоя',
                  'Наклеивание стеклоткани на потолок',
                  'Шлифование потолков'
                ]
              },
            ],
          },
          others: {
            airConditioners: 0,
            ventPoints: 0,
            mainDoor: false,
          },
        },
        finishing: { // Чистовые работы
          isActive: false,
          walls: {
            isActive: false,
            layers: [
              {
                name: 'Стеновые панели',
                tag: 'panels',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Монтаж стеновых панелей на каркасе',
              },
              {
                name: 'Покраска',
                tag: 'painting',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Покраска стен водоэмульсионной краской в 2 слоя',
              },
              {
                name: 'Обои',
                tag: 'wallpapers',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Поклейка обоев на стены',
              },
              {
                name: 'Декоративная штукатурка',
                tag: 'wallpapers',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Нанесение декоративной штукатурки на стены',
              },
              {
                name: 'Керамическая плитка / Керамогранит',
                tag: 'ceramic',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Укладка керамической плитки, керамогранита на стены с затиркой',
              },
              {
                name: 'Мелкоформатная плитка / Мозаика',
                tag: 'ceramic1',
                value: this.getRoomsValues('walls_square'),
                suffix: 'м²',
                original: 'Укладка мелкоформатной плитки, мозаики на стены с затиркой',
              },
            ]
          },
          slopes: {
            isActive: false,
            layers: [
              {
                name: 'Покраска',
                tag: 'painting',
                value: this.getRoomsValues('slopes_length'),
                suffix: 'мп',
                original: 'Покраска откосов водоэмульсионной краской в 2 слоя',
              },
            ]
          },
          floors: {
            isActive: false,
            layers1: [
              {
                name: 'Линолеум',
                tag: 'linoleum',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка линолеума на клей'
              },
              {
                name: 'Ламинат',
                tag: 'laminate',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка ламината на подложку'
              },
              {
                name: 'Кварцвиниловая плитка (на подложку)',
                tag: 'quartzvinyl',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка кварцвиниловой плитки на подложку'
              },
              {
                name: 'Кварцвиниловая плитка (на клей)',
                tag: 'quartzvinyl1',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка кварцвиниловой плитки на клей'
              },
              {
                name: 'Паркетная доска (на подложку)',
                tag: 'parket',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка паркетной доски на подложку'
              },
              {
                name: 'Паркетная доска (на клей)',
                tag: 'parket1',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка паркетной доски на клей'
              },
              {
                name: 'Массивная доска',
                tag: 'massive',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка массивной доски'
              },
              {
                name: 'Плитка / Керамогранит',
                tag: 'ceramic',
                value: this.getRoomsValues('floor_square'),
                suffix: 'м²',
                original: 'Укладка керамической плитки, керамогранита на пол с затиркой'
              },
              
            ],
            layers2: [
              {
                name: 'Число порогов',
                tag: 'threshold',
                value: this.getRoomsValues('', true, true),
                suffix: 'шт',
                original: 'Установка порожка'
              },
              {
                name: 'Плинтус ПВХ',
                tag: 'plinth',
                value: this.getRoomsValues('floor_perimeter'),
                suffix: 'мп',
                original: 'Установка плинтуса ПВХ'
              },
              {
                name: 'Плинтус МДФ',
                tag: 'plinth1',
                value: this.getRoomsValues('floor_perimeter'),
                suffix: 'мп',
                original: 'Установка деревянного плинтуса на клей'
              },
            ]
          },
          ceiling: {
            isActive: false,
            layers: [
              {
                name: 'Натяжной потолок',
                tag: 'stretch',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Изготовление и монтаж натяжных потолков (матовый, глянцевый)'
              },
              {
                name: 'Реечный потолок',
                tag: 'rack',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Монтаж реечных потолков'
              },
              {
                name: 'Подвесной потолок (Армстронг)',
                tag: 'armstrong',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Монтаж подвесных потолков Армстронг'
              },
              {
                name: 'Покраска',
                tag: 'painting',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Покраска потолков водоэмульсионной краской в 2 слоя'
              },
              {
                name: 'Обои',
                tag: 'wallpaper',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Поклейка обоев на потолки'
              },
              {
                name: 'Декоративная штукатурка',
                tag: 'decor',
                value: this.getRoomsValues('ceiling_square'),
                suffix: 'м²',
                original: 'Нанесение декоративной штукатурки на потолки'
              },
              {
                name: 'Потолочный плинтус',
                tag: 'plinth',
                value: this.getRoomsValues('ceiling_perimeter'),
                suffix: 'мп',
                original: 'Монтаж потолочного плинтуса'
              },
            ],
          },
          electric: {
            isActive: false,
            services: [
              {
                text: 'Розетка / выключатель',
                original: 'Установка розетки, выключателя',
                value: this.getObjectParam('electric_points_count')
              },
              {
                text: 'Люстра',
                original: 'Установка люстры (без сборки)',
                value: 0
              },
              {
                text: 'Потолочный светильник',
                original: 'Установка потолочного светильника',
                value: 0
              },
              {
                text: 'Настенный светильник',
                original: 'Установка настенного светильника',
                value: 0
              },
              {
                text: 'Светодиодная лента',
                original: 'Монтаж светодиодной ленты',
                value: 0,
              },
              {
                text: 'Эл. полотенцесушитель',
                original: 'Монтаж электрического полотенцесушителя',
                value: 0
              },
              {
                text: 'Электровентилятор',
                original: 'Установка электровентилятора',
                value: 0
              },
              {
                text: 'Электрическая плита',
                original: 'Подключение электрической плиты',
                value: 0
              },
              {
                text: 'Пожарный датчик',
                original: 'Установка пожарного датчика',
                value: 0
              },
              {
                text: 'Трубка домофона',
                original: 'Монтаж трубки домофона',
                value: 0
              },
            ]
          },
          water: {
            isActive: false,
            services: [
              {
                text: 'Смеситель',
                original: 'Установка смесителя',
                value: 0
              },
              {
                text: 'Раковина',
                original: 'Установка раковины',
                value: 0
              },
              {
                text: 'Вод. полотенцесушитель',
                original: 'Установка полотенцесушителя водяного',
                value: 0
              },
              {
                text: 'Водонагреватель (накопительный)',
                original: 'Подключение накопительного водонагревателя',
                value: 0
              },
              {
                text: 'Водонагреватель (проточный)',
                original: 'Подключение проточного водонагревателя',
                value: 0
              },
              {
                text: 'Дверь для душевой',
                original: 'Установка двери для душевого уголка',
                value: 0
              },
              {
                text: 'Душевая кабина',
                original: 'Сборка и установка душевой кабины',
                value: 0
              },
              {
                text: 'Ванна акриловая',
                original: 'Установка ванны акриловой',
                value: 0
              },
              {
                text: 'Ванна стальная',
                original: 'Установка ванны стальной',
                value: 0
              },
              {
                text: 'Ванна чугунная',
                original: 'Установка ванны чугунной',
                value: 0
              },
              {
                text: 'Унитаз напольный',
                original: 'Установка унитаза напольного',
                value: 0
              },
              {
                text: 'Унитаз подвесной',
                original: 'Установка унитаза подвесного',
                value: 0
              },
              {
                text: 'Стиральная / посудомоечная машина',
                original: 'Подключение стиральной, посудомоечной машины',
                value: 0
              },
              {
                text: 'Гигиенический душ',
                original: 'Установка гигиенического душа',
                value: 0
              },
              
            ]
          },
          others: {
            isActive: true,
            doors: this.objParams.rooms.length > 0 ? this.objParams.rooms.length - 1 : 0,
            mirrors: 0,
            cleaning: false
          },
        }
      }
    },

    parseServicesSelect(arr) {
      return arr.filter(x => Boolean(x.count)).map(x => ({
        original: x.name,
        value: x.count
      }));
    },

    parseServices(arr) {
      return arr.filter(x => x.value > 0).map(x => ({
        original: x.original,
        value: x.value
      }));
    },

    parseLayers(arr) {
      let services = [];
      for (let item of arr) {
        if (item.value[0].value > 0) {
          if (item.originalPie) {
            // Кейс - у нас есть "пирог" работ
            for (let serviceName of item.originalPie) {
              let service = {
                original: serviceName,
                value: item.value[0].value
              };
              if (!item.value[0].isActive) {
                service.byRooms = item.value.slice(1).filter(x => x.value > 0).map(x => ({
                  name: x.name,
                  value: x.value
                }));
              }
              services.push(service);
            }
          } else {
            if (item.originalWater) {
              // Кейс - нужно поделить работы на влажные / сухие по комнатам
              let service1 = {
                original: item.original,
                value: item.value[0].value
              };
              let service2 = {
                original: item.originalWater,
                value: 0
              };
              if (!item.value[0].isActive) {
                service1.byRooms = item.value.slice(1)
                  .filter(x => 
                    x.value > 0 &&
                    x.roomType != 'Санузел' &&
                    x.roomType != 'Балкон (лоджия)'
                  )
                  .map(x => ({
                    name: x.name,
                    value: x.value
                  }));
                service1.value = service1.byRooms.reduce((sum, cur) => sum + Number(cur.value), 0);
                service2.byRooms = item.value.slice(1)
                  .filter(x => 
                    x.value > 0 &&
                    (x.roomType == 'Санузел' ||
                    x.roomType == 'Балкон (лоджия)')
                  )
                  .map(x => ({
                    name: x.name,
                    value: x.value
                  }));
                service2.value = service2.byRooms.reduce((sum, cur) => sum + Number(cur.value), 0);
              }
              //console.log(service2);
              if (service1.value > 0) services.push(service1);
              if (service2.value > 0) services.push(service2);
            } else {
              // Кейс - обычная работа - просто добавляем ее в коллекцию
              let service = {
                original: item.original,
                value: item.value[0].value
              };
              if (!item.value[0].isActive) {
                service.byRooms = item.value.slice(1).filter(x => x.value > 0).map(x => ({
                  name: x.name,
                  value: x.value
                }));
              }
              services.push(service);
            }
            
          }          
        }
      }
      return services;
    },

    save() {
      this.$refs.form.validate();
      if (this.isValid) {
        // Вытаскиваем данные из Entity в стандартную форму - а именно
        // { original, value } по каждой позиции Работ
        let services = [];

        if (this.entity.dismantling.isActive) { // Этап 0
          if (this.entity.dismantling.isFull) {
            services.push({
              original: 'Комплексный демонтаж во вторичном жилье с вывозом мусора',
              value: this.getObjectParam('floor_square')
            });
          } else {
            services.push(
              ...this.entity.dismantling.services.filter(x => Boolean(x.count)).map(x => ({
                original: x.name,
                value: x.count
              }))
            );
          }
        }

        if (this.entity.design.isActive) { // Этап 1
          switch (this.entity.design.package) {
            case 'simple':
              services.push({
                original: 'Разработка планировочного решения',
                value: this.getObjectParam('floor_square')
              });
              break;
            case 'standart':
              services.push({
                original: 'Разработка комплекта рабочей документации',
                value: this.getObjectParam('floor_square')
              });
              break;
            case 'full':
              services.push({
                original: 'Разработка полного дизайн-проекта',
                value: this.getObjectParam('floor_square')
              });
              if (this.entity.design.plan3d > 0) {
                services.push({
                  original: 'Разработка 3D-визуализации помещения',
                  value: this.entity.design.plan3d
                });
              }
              break;
          }
        }
        
        if (this.entity.whitebox.isActive) { // Этап 2
          if (this.entity.whitebox.newWalls.isActive) { // 2.1.
            services.push(...this.parseServices(this.entity.whitebox.newWalls.services1));
            services.push(...this.parseServices(this.entity.whitebox.newWalls.services2));
            services.push(...this.parseServices(this.entity.whitebox.newWalls.services3));
          }
          if (this.entity.whitebox.electric.isActive) { // 2.2.
            services.push(...this.parseServices(this.entity.whitebox.electric.services));
          }
          if (this.entity.whitebox.water.isActive) { // 2.3.
            if (this.entity.whitebox.water.services1.value > 0) {
              services.push({
                original: this.entity.whitebox.water.services1.selectedItem,
                value: this.entity.whitebox.water.services1.value
              });
            }
            services.push(...this.parseServicesSelect(this.entity.whitebox.water.services2));
          }
          if (this.entity.whitebox.walls.isActive) { // 2.4
            services.push(...this.parseLayers(this.entity.whitebox.walls.layers));
          }
          if (this.entity.whitebox.slopes.isActive) { // 2.5
            services.push(...this.parseLayers(this.entity.whitebox.slopes.layers));
          }
          if (this.entity.whitebox.floors.isActive) { // 2.6
            services.push(...this.parseLayers(this.entity.whitebox.floors.layers));
          }
          if (this.entity.whitebox.ceiling.isActive) { // 2.7
            services.push(...this.parseLayers(this.entity.whitebox.ceiling.layers));
          }
          if (this.entity.whitebox.others.airConditioners > 0) {
            services.push({
              original: 'Монтаж трассы под сплит-систему (без установки блоков)',
              value: this.entity.whitebox.others.airConditioners
            });
            services.push({
              original: 'Монтаж наружнего блока кондиционера',
              value: this.entity.whitebox.others.airConditioners
            });
            services.push({
              original: 'Установка внутреннего блока кондиционера',
              value: this.entity.whitebox.others.airConditioners
            });
          }
          if (this.entity.whitebox.others.ventPoints > 0) {
            services.push({
              original: 'Устройство точки вентиляции',
              value: this.entity.whitebox.others.ventPoints
            });
          }
          if (this.entity.whitebox.others.mainDoor) {
            services.push({
              original: 'Установка входной двери',
              value: 1
            });
          }
        }
        
        if (this.entity.finishing.isActive) { // Этап 3
          if (this.entity.finishing.walls.isActive) { // 3.1
            //console.log(this.parseLayers(this.entity.finishing.walls.layers));
            services.push(...this.parseLayers(this.entity.finishing.walls.layers));
          }
          if (this.entity.finishing.slopes.isActive) { // 3.2
            services.push(...this.parseLayers(this.entity.finishing.slopes.layers));
          }
          if (this.entity.finishing.floors.isActive) { // 3.3
            services.push(...this.parseLayers(this.entity.finishing.floors.layers1));
            services.push(...this.parseLayers(this.entity.finishing.floors.layers2));
          }
          if (this.entity.finishing.ceiling.isActive) { // 3.4
            services.push(...this.parseLayers(this.entity.finishing.ceiling.layers));
          }
          if (this.entity.finishing.electric.isActive) { // 3.5
            services.push(...this.parseServices(this.entity.finishing.electric.services));
          }
          if (this.entity.finishing.water.isActive) { // 3.6
            services.push(...this.parseServices(this.entity.finishing.water.services));
          }
          if (this.entity.finishing.others.doors > 0) {
            services.push({
              original: 'Установка межкомнатной двери',
              value: this.entity.finishing.others.doors
            });
          }
          if (this.entity.finishing.others.mirrors > 0) {
            services.push({
              original: 'Установка зеркала',
              value: this.entity.finishing.others.mirrors
            });
          }
          if (this.entity.finishing.others.cleaning) {
            services.push({
              original: 'Послестроительная уборка объекта',
              value: this.getObjectParam('floor_square')
            });
          }
        }
        
        this.$emit('save', services);
      } else {
        this.error = true;
      }
    },

    cancel() {
      this.$emit('cancel');
    },
  },
}
</script>